import { useState, type FormEvent } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { referralsService } from '@/services/referralsService'
import { ParceirosBrandShell } from '@/pages/parceiros/ParceirosBrandShell'
import { ParceiroTermosAceite } from '@/pages/parceiros/ParceiroTermosAceite'
import { readParceiroTermosNavegador } from '@/pages/parceiros/parceiroTermosNavegador'
import {
  PARCEIROS_ACCENT,
  PARCEIROS_LOGIN_PATH,
  fieldClass,
  labelClass,
} from '@/pages/parceiros/parceirosBrand'

export default function PortalIndicacoesCadastro() {
  const [searchParams] = useSearchParams()
  const closerLink = searchParams.get('c')?.trim() || undefined
  const [nome, setNome] = useState('')
  const [empresa, setEmpresa] = useState('')
  const [telefone, setTelefone] = useState('')
  const [email, setEmail] = useState('')
  const [aceitouTermos, setAceitouTermos] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    setMessage('')
    if (!aceitouTermos) {
      setError('É preciso aceitar as regras do programa de indicação.')
      setSubmitting(false)
      return
    }
    try {
      const navegador = await readParceiroTermosNavegador()
      await referralsService.register({
        nome,
        empresa,
        telefone,
        email,
        aceitouTermos: true,
        ...navegador,
        ...(closerLink && closerLink.length >= 20 ? { closer: closerLink } : {}),
      })
      setNome('')
      setEmpresa('')
      setTelefone('')
      setEmail('')
      setAceitouTermos(false)
      setMessage('Cadastro enviado. A equipe RocketSearch vai validar seus dados e liberar o acesso assim que tudo estiver aprovado.')
    } catch {
      setError('Não foi possível enviar o cadastro. Tente de novo.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <ParceirosBrandShell
      rightSlot={
        <Link
          to={PARCEIROS_LOGIN_PATH}
          className='rounded-full px-4 py-2 text-sm font-medium text-white active:scale-95'
          style={{ background: PARCEIROS_ACCENT }}
        >
          Já sou parceiro
        </Link>
      }
    >
      <div className='mx-auto grid max-w-lg gap-6'>
        <div>
          <p className='text-[11px] font-medium uppercase tracking-[0.28em] text-white/55'>Programa de indicação</p>
          <h1 className='mt-2 text-3xl font-black'>Quero indicar clientes</h1>
          <p className='mt-2 text-white/70'>Cadastre-se. A equipe valida e libera o acesso para enviar leads.</p>
        </div>
        {message ? (
          <div className='rounded-3xl border border-[#e91e63]/30 bg-[#e91e63]/10 p-6 text-center shadow-[0_24px_80px_rgba(233,30,99,0.16)] backdrop-blur-xl'>
            <p className='text-[11px] font-medium uppercase tracking-[0.28em] text-[#ff8fbd]'>Cadastro recebido</p>
            <h2 className='mt-3 text-2xl font-black text-white'>Tudo certo por aqui.</h2>
            <p className='mt-3 text-sm leading-6 text-white/70'>{message}</p>
          </div>
        ) : (
          <form onSubmit={submit} className='grid gap-4 rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl'>
            <label className='grid gap-1.5'>
              <span className={labelClass}>Seu nome</span>
              <input className={fieldClass} value={nome} onChange={(e) => setNome(e.target.value)} required minLength={2} />
            </label>
            <label className='grid gap-1.5'>
              <span className={labelClass}>Empresa ou negócio</span>
              <input className={fieldClass} value={empresa} onChange={(e) => setEmpresa(e.target.value)} required minLength={2} />
              <span className='text-xs leading-5 text-white/55'>
                Profissional liberal: use o nome do negócio pelo qual você indica.
              </span>
            </label>
            <label className='grid gap-1.5'>
              <span className={labelClass}>Telefone</span>
              <input className={fieldClass} value={telefone} onChange={(e) => setTelefone(e.target.value)} required minLength={8} />
            </label>
            <label className='grid gap-1.5'>
              <span className={labelClass}>E-mail</span>
              <input className={fieldClass} type='email' value={email} onChange={(e) => setEmail(e.target.value)} required />
            </label>
            <p className='text-xs leading-5 text-white/55'>
              Ao enviar, guardamos a data, o IP, o navegador, o idioma, o fuso e, se você permitir, a localização aproximada deste aparelho.
            </p>
            <ParceiroTermosAceite checked={aceitouTermos} onChange={setAceitouTermos} />
            {error && <p className='text-sm text-red-300'>{error}</p>}
            <button
              type='submit'
              disabled={submitting || !aceitouTermos}
              className='rounded-full px-5 py-3 text-sm font-medium text-white active:scale-95 disabled:opacity-50'
              style={{ background: PARCEIROS_ACCENT }}
            >
              {submitting ? 'Enviando…' : 'Enviar cadastro'}
            </button>
          </form>
        )}
      </div>
    </ParceirosBrandShell>
  )
}
